import type { ProductResponse } from "../../admin/products/productsApi";
import type { Currency } from "../../data/BaseEntity";

export function currencyForProduct(availableProducts: ProductResponse[], productId?: string): Currency | undefined {
  return availableProducts.find((product) => product.id === productId)?.currency;
}
